<!-- <div class="">
  <div class="row-flex">
    <div class="background-menu e5-border-right side-nav-top">
      <div [ngClass]="{'rectangle':selectedIndex==10,'':selectedIndex!=10}" class="profile-image-margin">
        <img src="/assets/images/Group.png" class="profile-image" (click)="profileClick()" alt="Capitaland Image">
      </div>
      <div class="sidenav-margin link" *ngFor="let item of allSideNav;let i = index" (click)="selectNav(item)">
        <img [src]="selectedIndex==i?item.selectedImage:item.image"
          class="pl-3 sidenav-menu-images align-items-center align-self-center" />
        <div class=" align-items-center align-self-center"
          [ngClass]="{'menu-onload':selectedIndex!=i,'menu-selected':selectedIndex==i}">
          {{item?.name}}
        </div>
        <div class="side-top rectangle " *ngIf="selectedIndex==i"></div>
      </div>
    </div>
  </div>
</div> -->

<div class="">
  <div class="row-flex">
    <div class="e5-border-right side-nav-top"
      [ngClass]="{'background-menu-bridge' : userType === 'Bridge+', 'background-menu-parkite' : userType !== 'Bridge+'}">
      <div class="profile-image-margin" (click)="profileClick()">
        <div [ngClass]="{'rectangle':selectedIndex==10,'':selectedIndex!=10}"></div>
        <!-- <img src="/assets/images/Group.png" class="profile-image" alt="Capitaland Image"
          *ngIf="adminData?.image !== undefined && adminData?.image !== null" loading="lazy" /> -->
        <div class="profile-image-letter"
          *ngIf="adminData?.image == undefined || adminData?.image == null || adminData?.image == ''">
          <span>
            {{initials}}
          </span>
        </div>
      </div>


      <!-- <div class="sidenav-margin link" *ngFor="let item of allSideNav;let i = index">

        <div class=" sidenav-box" *ngIf="item.sub.length==0"
          [ngClass]="{'menu-onload':selectedIndex!=i,'menu-selected':selectedIndex==i}"
          (click)="selectNav(item,0);toggle('close')">
          <img [src]="selectedIndex==i?item.selectedImage:item.image" class="" loading="lazy" />
          {{item?.name}}
        </div>


        <div [ngClass]="!expandVMS?'link':'sub-link pt-1'" *ngIf="item.sub.length!=0">
          <div (click)="selectNav(item,0);toggle('toggle')"
            [ngClass]="{'menu-onload':selectedIndex!=i,'menu-selected':selectedIndex==i}">
            <img [src]="selectedIndex==i?item.selectedImage:item.image" class="" loading="lazy" />
            <p class="mt-2">{{item?.name}}</p>
          </div>
          <div class="link" *ngIf="expandVMS">
            <div *ngFor="let sub of item.sub;let j=index">
              <div (click)="selectNav(item,j);" [ngClass]="{'menu-onload':subIndex!=j,'menu-selected':subIndex==j}">
                <div class="verticleLine"></div>
                {{sub?.name}}
              </div>
              <div class="rectangle-sub " *ngIf="subIndex==j"></div>

            </div>

          </div>
        </div>

        <div class="rectangle " *ngIf="selectedIndex==i && item?.sub?.length==0"></div>

      </div> -->


      <div *ngFor="let item of allSideNav ;let i = index">
        <div class="sidenav-margin link" *ngIf="item.sub.length==0" (click)="selectNav(item,0);toggle('close')">

          <div class=" sidenav-box" [ngClass]="{'menu-onload':selectedIndex!=i,'menu-selected':selectedIndex==i}">
            <img [src]="selectedIndex==i?item.selectedImage:item.image" class="" loading="lazy" />
            {{item?.name}}
          </div>
          <div class="rectangle " *ngIf="selectedIndex==i"></div>
        </div>
        <div  [ngClass]="!(expandVMS || expandPMS)?'link':'sub-link pt-1 pb-2'" *ngIf="item.sub.length!=0">
          <div (click)="toggle('toggle');selectNav(item,0)" [ngClass]="{'menu-onload':selectedIndex!=i,'menu-selected-sub':selectedIndex==i}">
            <img [src]="selectedIndex==i?item.selectedImage:item.image" class="" loading="lazy" />
            <p class="mt-2">{{item?.name}}</p>
          </div>
          <div class="link " *ngIf="expandVMS || expandPMS">
            <div *ngFor="let sub of item.sub;let j=index">
              <div (click)="selectNav(item,j)" [ngClass]="{'menu-onload':subIndex!=j,'menu-selected':subIndex==j}">
                <div class="verticleLine"></div>
                {{sub?.name}}
              <div class="sub-rectangle " *ngIf="subIndex==j"></div>

              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>
